import { Component, OnInit } from '@angular/core';

interface client {
  image: string;
};

@Component({
  selector: 'app-clients-logo',
  templateUrl: './clients-logo.component.html',
  styleUrls: ['./clients-logo.component.css']
})
export class ClientsLogoComponent implements OnInit {

  /**
   * Clients Logo
   */
   clients_logo: client[] = [
    {
      image: "assets/images/client/salesforce.svg"
    },
    {
      image: "assets/images/client/aws.svg"
    },
    {
      image: "assets/images/client/angular.svg"
    },
    {
      image: "assets/images/client/ionic.svg"
    },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
